jQuery(document).ready(function(){
  jQuery(".my-btn-header").on('click', function(){

    jQuery('.my-modal-header').show();
    jQuery('body').addClass('help-popup-active');
  })
  
    jQuery(".mobile-help").on('click', function(){
  
      jQuery('.my-modal-header').show();
      jQuery('body').addClass('help-popup-active');
  })
    jQuery(".help-pop-close").on('click', function(){
  
      jQuery('.my-modal-header').hide();
      jQuery('body').removeClass('help-popup-active');
  })

  if(jQuery("body").hasClass("template-product")){
    reviewInterval=setInterval(() => {
      console.log("enter");
        if(jQuery(".productView-tab .mobile-buttons.opw-font-medium").length > 0){
            if(jQuery(".productView-tab .opw-reviews-container").length < 1 )  {

              console.log("enter");
              if(jQuery("#tab-review .toggleLink.show-mobile").hasClass("is-open")){
                // jQuery(".toggleLink.show-mobile").removeClass("is-open");
                 var event = new MouseEvent('click', {  
                    bubbles: true,  
                    cancelable: true  
                });  
                
                document.querySelector('#tab-review .toggleLink.show-mobile').dispatchEvent(event); 
                 clearInterval(reviewInterval);
                }
               
            }else{
              clearInterval(reviewInterval);
            }
        }
    }, 200);
  }
  
  
})
